import { schedularTherapistFilterAction } from 'src/redux/actions/constant';


const intialState: object = {
  response: null,
  isTaskMinEdited: false,
  loading: false,
};

export const editSplitTaskMinReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isTaskMinEdited: true,
        loading: false,
      };
    }
    case  schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_FAILURE : {
      return {
        ...state,
        response: action.payload,
        isTaskMinEdited: false,
        loading: false,
      };
    }

    case schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_LOADING:
      return {
        ...state,
        loading: true,
      };

    case schedularTherapistFilterAction.EDIT_SPLIT_TASK_MIN_RESET:
      return intialState   


    default:
      return state;
  }
};
